import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeClosedGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M2.464 8.037a1 1 0 0 1 .695 1.231l-.696 2.5a1 1 0 1 1-1.926-.536l.696-2.5a1 1 0 0 1 1.231-.695m19.072 0a1 1 0 0 1 1.231.695l.696 2.5a1 1 0 0 1-1.926.536l-.696-2.5a1 1 0 0 1 .695-1.231M6.705 12.02a1 1 0 0 1 .774 1.184l-.5 2.392a1 1 0 1 1-1.958-.41l.5-2.392a1 1 0 0 1 1.184-.774m10.59 0a1 1 0 0 1 1.184.774l.5 2.393a1 1 0 1 1-1.958.409l-.5-2.392a1 1 0 0 1 .774-1.184M12 13a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M1.792 8.085a1 1 0 0 1 1.319.51C4.347 11.396 7.999 13 12 13s7.653-1.605 8.89-4.404a1 1 0 0 1 1.829.808C21.01 13.272 16.33 15 12 15S2.99 13.272 1.281 9.404a1 1 0 0 1 .511-1.319'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeClosedGhost)
export default ForwardRef
